import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { coerceArray, TFileType } from '@partners/utils';
import { IFileTypeValidationHandler, TValidatorError } from '../../model';

const isFileTypeInvalid =
  (validFileTypes: TFileType[], enableBase64String: boolean = false) =>
  (file: File | string) => {
    // if the file type is string, and string is enabled as valid type, returns valid value.
    // if string is disabled as valid type, returns invalid value.
    if (typeof file === 'string') return !enableBase64String;

    // else, if the file type is not file, it's invalid
    if (!(file instanceof File)) return true;
    if (!validFileTypes.includes(file.type as TFileType)) return true;

    return false;
  };

export function fileTypeValidator({ validFileTypes, enableBase64String }: IFileTypeValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files: (File | string)[] | File | string | null = control.value;
    if (!files || !validFileTypes?.length) return null;

    // Handle single file or array of files
    const fileList = coerceArray(files);

    const isFileInvalid = !!fileList.find(isFileTypeInvalid(validFileTypes, enableBase64String));

    if (isFileInvalid) {
      const fileType = {
        allowed: validFileTypes
      };
      const vldResponse: TValidatorError = { fileType: fileType };
      return vldResponse;
    }

    return null;
  };
}
